<template>
  <div>
    <LoaderApp v-if="loading"></LoaderApp>
    <div v-else>
      <div class="card">
        <div class="no-gutters row">
          <div class="col-12">
            <div class="widget-content" style="border-bottom: 1px solid rgba(0,0,0,0.125);">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3">
                  <h4 class="m-0 widget-heading">Objetivo:</h4>
                </div>
                <div class="widget-content-left">
                  <h4
                    class="m-0 widget-heading"
                  ><span class="text-alternate">{{objetivo.cantidad}}</span> unidades de <span class="text-primary">{{objetivo.articulo.descripcion}}</span></h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Desde:</p>
                </div>
                <div class="widget-content-left">
                  <p class="text-success m-0 widget-heading">{{objetivo.desde}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Hasta:</p>
                </div>
                <div class="widget-content-left">
                  <p class="text-success m-0 widget-heading">{{objetivo.hasta}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="card p-0 mt-2 col-12" v-for="detalle in objetivo.detalle" :key="detalle.id">
          <div class="card-body">
            <h5 class="card-title text-primary my-0">{{detalle.user.nombre}}:</h5>
            <h6 class="mt-0 font-weight-bold"><span class="text-alternate">{{detalle.cantidad}}</span> unidades vendidas.</h6>
            <p class="mb-0 font-weight-bold">Completado: {{((detalle.cantidad/objetivo.cantidad)*100)}}%</p>
            <div class="progress">
              <div
                class="progress-bar progress-bar-animated bg-info  progress-bar-striped"
                role="progressbar"
                :aria-valuenow="((detalle.cantidad/objetivo.cantidad)*100)"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="'width: '+((detalle.cantidad/objetivo.cantidad)*100)+'%;'"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="card p-2 mt-2">
        <div class="row">
          <div class="col-md-2">
            <button
              class="btn btn-info btn-block mb-2 mb-md-0"
              type="button"
              @click="$router.go(-1)"
            >Volver</button>
          </div>
          <!-- <div class="col-md-2 offset-md-6">
            <router-link
              class="btn btn-block btn-warning text-white mb-2 mb-md-0"
              :to="{name:'EditarObjetivo', params:{id:objetivo.id}}"
            >Editar</router-link>
          </div>-->
          <div class="offset-md-8 col-md-2">
            <button
              class="btn btn-danger btn-block mb-2 mb-md-0"
              type="button"
              @click="EliminarObjetivo()"
            >Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Objetivo from "@/models/objetivo";
import Swal from "sweetalert2";
import axios from "axios";
import LoaderApp from "@/components/loaders/LoaderApp";
export default {
  name: "VerObjetivo",
  components: {
    LoaderApp
  },
  data() {
    return {
      objetivo: new Objetivo(null, null, null, null, null, null, null),
      loading: true
    };
  },
  mounted() {
    this.objetivo.id = this.$route.params.id;
    this.getObjetivo();
  },
  methods: {
    getObjetivo() {
      this.loading = true;
      axios
        .get("/objetivos/" + this.objetivo.id)
        .then(res => {
          if (res.data.success) {
            this.objetivo = res.data.objetivo;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    eliminarObjetivo() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar el objetivo de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/objetivos/" + this.objetivo.id)
            .then(() => {
              Swal.fire(
                "Eliminado",
                `El objetivo se ha eliminado con éxito.`,
                "success"
              );
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>